import { getEnvironmentUrlApiV2 } from './getEnvironmentUrlApiV2';

export const deleteVideo = (
  authToken: string,
  environment: Parameters<typeof getEnvironmentUrlApiV2>[0],
  videoId: string,
) => {
  const params = new URLSearchParams({ videoId });
  return fetch(`${getEnvironmentUrlApiV2(environment)}videos?${params.toString()}`, {
    method: 'DELETE',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    }),
  }).then((res) => {
    if (!res.ok) {
      console.error(`Could not delete video: ${res.status} ${res.statusText}`);
      return false;
    }
    return res.json();
  });
};
